export const GrossProfitItemLabelTextHelper = {
    getLabelText: {
        grossProfitItemId: 'Gross Profit Item ID',
        grossProfitId: 'Gross Profit ID',
        productId: 'Product ID',
        orderItemId: 'Order Item ID',
        quantity: 'Quantity',
        productCostAmountBaseCurrency: 'Unit Cost HKD',
        itemUnitPriceAmountBaseCurrency: 'Unit Price HKD',
        itemUnitGrossProfitAmountBaseCurrency: 'Unit GP HKD',
        dateCreateAt: 'Create date',
        dateModifyAt: 'Modify date'
    }
};
